<template>
    <base-modal @close="$emit('close')">
        <div
            slot="header"
            class="h3"
        >
            Sélectionnez les nouvelles valeurs
        </div>

        <div slot="body">
            <div
                v-for="(choix_champs, key) in params.questions"
                :key="key"
                class="form-row mt-4"
            >
                <div class="col-6">
                    <base-select
                        v-model="params.questions[key]"
                        :errors="errors.choix_champs"
                        :options="emplacement === 'dossier' ? champsDossierModifiables : champsEchangeModifiables "
                    >
                        Choix du champs
                    </base-select>
                </div>

                <div
                    v-if="params.questions[key] === 'regime_tva'"
                    class="col-3"
                >
                    <base-select
                        v-model="params.modification.regime_tva"
                        :options="optionsRegimesTVA"
                    >
                        Régime TVA
                    </base-select>
                </div>

                <div
                    v-if="params.questions[key] === 'logiciel_compta'"
                    class="col-3"
                >
                    <base-select
                        v-model="params.modification.logiciel_compta"
                        :options="optionsLogicielCompta"
                    >
                        Logiciel de compatbilité
                    </base-select>
                </div>

                <div
                    v-if="params.questions[key] === 'superviseur_id'"
                    class="col-4"
                >
                    <base-select
                        v-model="params.modification.superviseur_id"
                        :options="optionsSuperviseurs"
                    >
                        Superviseur
                    </base-select>
                </div>

                <div
                    v-if="params.questions[key] === 'equipe_id'"
                    class="col-4"
                >
                    <base-select
                        v-model="params.modification.equipe_id"
                        :options="optionsEquipes"
                    >
                        Équipe
                    </base-select>
                </div>

                <div
                    v-if="params.questions[key] === 'collaborateur_id'"
                    class="col-4"
                >
                    <base-select
                        v-model="params.modification.collaborateur_id"
                        :options="optionsCollaborateurs"
                    >
                        Collaborateur
                    </base-select>
                </div>

                <div
                    v-if="params.questions[key] === 'administratif_id'"
                    class="col-4"
                >
                    <base-select
                        v-model="params.modification.administratif_id"
                        :options="optionsAdministratifs"
                    >
                        Administratif
                    </base-select>
                </div>

                <div
                    v-if="params.questions[key] === 'date_cloture'"
                    class="col-3"
                >
                    <base-select
                        v-model="params.modification.date_cloture"
                        :options="optionsClotures"
                        no-search
                    >
                        Clôture
                    </base-select>
                </div>

                <div
                    v-if="params.questions[key] === 'responsable_tva_equipe_id'"
                    class="col-4"
                >
                    <base-select
                        v-model="params.modification.responsable_tva_equipe_id"
                        :options="optionsEquipes"
                    >
                        Responsable TVA
                    </base-select>
                </div>

                <div
                    v-if="params.questions[key] === 'collaborateur_tva_id'"
                    class="col-4"
                >
                    <base-select
                        v-model="params.modification.collaborateur_tva_id"
                        :options="optionsCollaborateurs"
                    >
                        Collaborateur TVA
                    </base-select>
                </div>

                <div
                    v-if="params.questions[key] === 'is_assujetti_cfe'"
                    class="col-3"
                >
                    <base-select
                        v-model="params.modification.is_assujetti_cfe"
                        :options="optionsCfe"
                    >
                        Assujetti CFE
                    </base-select>
                </div>

                <div
                    v-if="params.questions[key] === 'is_cga'"
                    class="col-3"
                >
                    <base-select
                        v-model="params.modification.is_cga"
                        :options="optionsOuiNon"
                    >
                        CGA
                    </base-select>
                </div>

                <div
                    v-if="params.questions[key] === 'has_bank_account'"
                    class="col-3"
                >
                    <base-select
                        v-model="params.modification.has_bank_account"
                        :options="optionsOuiNon"
                    >
                        Compte bancaire
                    </base-select>
                </div>

                <div
                    v-if="params.questions[key] === 'statut_id'"
                    class="col-4"
                >
                    <base-select
                        v-model="params.modification.statut_id"
                        :options="optionsStatuts"
                    >
                        Statut
                    </base-select>
                </div>

                <div
                    v-if="params.questions[key] === 'date_prise_effet_changement_regime'"
                    class="col-5"
                >
                    <base-input
                        v-model="params.modification.date_prise_effet_changement_regime"
                        type="date"
                    >
                        Date de prise d'effet du changement de régime
                    </base-input>
                </div>

                <div
                    v-if="params.questions[key] === 'lieux_collecte_id'"
                    class="col-3"
                >
                    <base-select
                        v-model="params.modification.lieux_collecte_id"
                        :options="optionsLieuxCollectes"
                    >
                        Lieu de collecte
                    </base-select>
                </div>

                <div
                    v-if="params.questions[key] === 'lieux_production_id'"
                    class="col-3"
                >
                    <base-select
                        v-model="params.modification.lieux_production_id"
                        :options="optionsLieuxProductions"
                    >
                        Lieu de production
                    </base-select>
                </div>

                <div
                    v-if="params.questions[key] === 'is_mail_simplifie'"
                    class="col-3"
                >
                    <base-select
                        v-model="params.modification.is_mail_simplifie"
                        :options="optionsTypeMailCollecte"
                    >
                        Type mail collecte
                    </base-select>
                </div>

                <div
                    v-if="params.questions[key] === 'attributed_to_id'"
                    class="col-4"
                >
                    <base-select
                        v-model="params.modification.attributed_to_id"
                        :options="optionsUsers"
                    >
                        Échange attribué à
                    </base-select>
                </div>

                <div
                    v-if="params.questions[key] === 'statut_question'"
                    class="col-5"
                >
                    <base-select
                        v-model="params.modification.statut_question"
                        :options="optionsStatutQuestion"
                    >
                        Statut de question
                    </base-select>
                </div>

                <div
                    v-if="params.questions[key] === 'is_cosmo'"
                    class="col-5"
                >
                    <base-select
                        v-model="params.modification.is_cosmo"
                        :options="optionsOuiNon"
                    >
                        Collecte Cosmo
                    </base-select>
                </div>
            </div>

            <div class="form-row mt-4">
                <button
                    class="btn btn-info mt-3 px-4 mr-2 float-right"
                    @click="params.questions.push(null)"
                >
                    <i class="fa fa-plus" />
                    Ajouter un champs à modifier
                </button>
            </div>
        </div>

        <div slot="footer">
            <div
                v-if="items && items.length > 0"
            >
                <button
                    class="btn btn-success"
                    :disabled="!params.questions[0]"
                    @click="confirmModification"
                >
                    Modifier ces valeurs en série
                </button>
            </div>
        </div>
    </base-modal>
</template>

<script>
    import BaseModal from "../templates/BaseModal"
    import DossierSearch from "../../mixins/DossierSearch"
    import BaseSelect from "../templates/BaseSelect"
    import BaseInput from "../templates/BaseInput"
    import {mapGetters} from "vuex"

    export default {
        name: "SelectionMassModificationModal",

        components: {BaseInput, BaseModal, BaseSelect},

        mixins: [DossierSearch],

        props: {
            additionalParams: {type: Object, default: () => {return {}}},
            type: {type: String, default: null},
            emplacement: {type: String, default: null},
        },

        data: function () {
            return {
                params: {
                    questions: [ null ],
                    modification: {},
                    ...this.additionalParams,
                },

                selectedDossiers: [],

                champsDossierModifiables: [
                    {value: 'regime_tva', label: 'Régime TVA'},
                    {value: 'logiciel_compta', label: 'Logiciel de comptabilité'},
                    {value: 'superviseur_id', label: 'Superviseur'},
                    {value: 'equipe_id', label: 'Équipe'},
                    {value: 'collaborateur_id', label: 'Collaborateur'},
                    {value: 'administratif_id', label: 'Administratif'},
                    {value: 'responsable_tva_equipe_id', label: 'Responsable TVA'},
                    {value: 'collaborateur_tva_id', label: 'Collaborateur TVA'},
                    {value: 'date_cloture', label: 'Clôture'},
                    {value: 'is_assujetti_cfe', label: 'Assujetti CFE'},
                    {value: 'is_cga', label: 'CGA'},
                    {value: 'has_bank_account', label: 'Compte bancaire'},
                    {value: 'statut_id', label: 'Statut'},
                    {value: 'date_prise_effet_changement_regime', label: 'Date de prise d\'effet du changement de régime'},
                    {value: 'lieux_collecte_id', label: 'Lieu de collecte'},
                    {value: 'lieux_production_id', label: 'Lieu de production'},
                    {value: 'is_mail_simplifie', label: 'Type mail collecte'},
                    {value: 'is_cosmo', label: 'Collecte Cosmo'},
                ],
                champsEchangeModifiables: [
                    {value: 'attributed_to_id', label: 'Attribué à'},
                    {value: 'statut_question', label: 'Statut de question'},
                ],
                optionsCfe: [
                    {value: 2, label: 'Oui Cabinet'},
                    {value: 1, label: 'Oui Client'},
                    {value: 0, label: 'Non'},
                ],
                optionsOuiNon: [
                    {value: 1, label: 'Oui'},
                    {value: 0, label: 'Non'},
                ],
                optionsTypeMailCollecte: [
                    {value: 0, label: 'Classique'},
                    {value: 1, label: 'Simplifié'},
                    {value: 2, label: 'Société'},
                ],
            }
        },

        computed: {
            ...mapGetters([
                'optionsEquipes',
                'optionsStatuts',
                'optionsSuperviseurs',
                'optionsClotures',
                'optionsRegimesTVA',
                'optionsCollaborateurs',
                'optionsAdministratifs',
                'optionsLieuxProductions',
                'optionsLieuxCollectes',
                'optionsUsers',
                'optionsStatutQuestion',
                'optionsLogicielCompta',
            ]),
        },

        methods: {
            confirmModification: function() {
                delete this.params.paginate
                this.params.questions.forEach((key) => {
                    this.params.modification[key] = this.params.modification.hasOwnProperty(key) ? this.params.modification[key] : null
                })

                axios.patch('/api/'+ (this.emplacement === 'dossier' ? 'dossiers' : 'echange-clients') + '/modification-en-serie', this.params)
                    .then(()=> {
                        this.$notify('success', `Cela a bien été mis à jour.`)
                        this.$emit('close')
                    })
                    .catch(() => this.$notify('danger', 'Une erreur est survenue lors de la modification.'))
            },
        }
    }
</script>
